import { InformationCircleIcon } from '@heroicons/react/24/outline';

interface DisabledReasonProps {
  /**
   * 表示する理由。null / undefined / 空文字なら何も描画しない
   * （＝ボタンが有効なとき）。
   */
  reason?: string | null;
  /** テキストの寄せ方（デフォルト: フル幅ボタン向けの中央寄せ） */
  align?: 'left' | 'center';
  /** ボタン側の aria-describedby から参照させたいときに指定 */
  id?: string;
  className?: string;
}

/**
 * 無効化されたボタンの理由表示。
 *
 * 決定ボタン（保存・追加・送信・確定など、そのフォーム／ダイアログの主アクション）を
 * 条件付きで `disabled` にするときは、必ずこのコンポーネントで理由を添える。
 * 送信中などの一時的な無効化（スピナー表示で理由が自明なもの）は対象外。
 *
 * @example
 * const reason = !name.trim() ? '名前を入力してください' : null;
 * <button disabled={!!reason} aria-describedby="add-reason">追加</button>
 * <DisabledReason id="add-reason" reason={reason} />
 */
export function DisabledReason({
  reason,
  align = 'center',
  id,
  className = '',
}: DisabledReasonProps) {
  if (!reason) return null;
  return (
    <p
      id={id}
      className={`mt-1.5 flex items-center gap-1 text-xs text-warning-600 ${
        align === 'center' ? 'justify-center' : ''
      } ${className}`}
    >
      <InformationCircleIcon className="w-3.5 h-3.5 flex-shrink-0" />
      <span>{reason}</span>
    </p>
  );
}

export default DisabledReason;
